export enum OrderItemVariant {
  Green = 'green',
}
